import mammoth from "mammoth";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  "pdfjs-dist/build/pdf.worker.min.mjs",
  import.meta.url
).toString();

export async function extractTextFromFile(file) {
  const name = String(file?.name || "").toLowerCase();
  const mime = String(file?.type || "").toLowerCase();

  if (mime === "text/plain" || name.endsWith(".txt")) {
    return file.text();
  }

  if (mime.includes("pdf") || name.endsWith(".pdf")) {
    const buffer = await file.arrayBuffer();
    const loadingTask = pdfjsLib.getDocument({ data: buffer });
    const pdf = await loadingTask.promise;
    const pages = [];
    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum += 1) {
      const page = await pdf.getPage(pageNum);
      const content = await page.getTextContent();
      const line = (content.items || [])
        .map((item) => String(item?.str || "").trim())
        .filter(Boolean)
        .join(" ");
      if (line) pages.push(line);
    }
    return pages.join("\n");
  }

  if (name.endsWith(".doc")) {
    const raw = await file.text();
    const cleaned = String(raw || "")
      .replace(/[\x00-\x08\x0E-\x1F]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    if (!cleaned) {
      throw new Error("Could not read this DOC file. Please convert it to .docx and try again.");
    }
    return cleaned;
  }

  if (mime.includes("officedocument.wordprocessingml.document") || name.endsWith(".docx")) {
    const buffer = await file.arrayBuffer();
    try {
      const result = await mammoth.extractRawText({ arrayBuffer: buffer });
      const text = String(result?.value || "").trim();
      if (!text) {
        throw new Error("No readable text found in this DOCX file.");
      }
      return text;
    } catch (_err) {
      throw new Error("Could not read this DOCX file. Please re-save it as .docx and try again.");
    }
  }

  throw new Error("Unsupported file type. Please upload a text file (.txt, .pdf, .doc, or .docx).");
}
